export default __webpack_public_path__ + "static/media/icon-user.853c06de.svg";